import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async fetchProgressAnalysis({ commit }, { pId, vId, pvId }) {
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "");
    return Vue.axios.get(Vue.$url("progress-analysis" + query)).then((rsp) => commit("SET_PROGRESS_ANALYSIS", rsp.data));
  },

  async createProgressAnalysis({ commit }, payload) {
    return Vue.axios.post(Vue.$url("progress-analysis"), payload).then((rsp) => {
      Vue.$log.debug("progress analysis created and saved under", rsp.data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Progress analysis", 1: payload.task }), { root: true });
    });
  },

  async updateProgressAnalysis({ commit }, payload) {
    return Vue.axios.put(Vue.$url("progress-analysis/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Progress analysis", 1: payload.task }), { root: true });
    });
  },

  async deleteProgressAnalysis({ commit }, payload) {
    Vue.$log.debug("trying to delete entity", payload.id);
    return Vue.axios.delete(Vue.$url("progress-analysis/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.task }), { root: true });
    });
  },
};
